var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('span',{staticClass:"copyable",attrs:{"title":'点击复制' + (_vm.label ? ' ' + _vm.label : '')},on:{"click":function($event){$event.stopPropagation();return _vm.onCopy.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.display))]):_c('span',{staticClass:"muted"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }